<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-05-20 14:30:34
 * @LastEditTime: 2020-10-22 10:12:28
-->
<<template>
  <div>
  </div>
</template>
<script>
export default {
  props:
    {
      title:{
        type:String,
        default:()=>'提示'
      }
    }
  ,
  data(){
    return{
    }
  },
  methods:{
    //删除提示框组件---接收当前父组件传过来的索引值，点击确定按钮调用父组件删除事件
    opendelete(index) {
        this.$confirm(this.$t('lang.DeleteBox.Tetx'), this.title=="提示"?this.$t("lang.editVar.msg22"):this.title, {
          confirmButtonText: this.$t('lang.DeleteBox.confirmButtonText'),
          cancelButtonText: this.$t('lang.DeleteBox.cancelButtonText'),
          type: 'warning',
          center: true
        }).then(() => {
          this.$emit('removelist',index)
        }).catch(() => {
          
        });
      }
  }
}
</script>
<style scoped>

</style>
